export const Popup = () => {
  return (
    <>
      <div className="bg-darkGradient max-w-72 p-6  rounded-xl z-50 text-center space-y-2 relative">
        <h5 className="text-2xl font-semibold text-white">Oops!</h5>
        <p className="text-sm font-normal text-white">
          Login to Capture your Bits
        </p>
        <button className="text-sm font-normal text-white rounded-lg bg-RedT px-8 py-2 !mt-6">
          Signup
        </button>
      </div>
    </>
  );
};
